"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WrappedLoginForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _CornerstoneForm = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneForm"));

var _Row = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Row"));

var _Col = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Col"));

var _Loader = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Loader"));

var _CornerstoneIcon = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneIcon"));

var _CornerstoneButton = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneButton"));

var _PromiseModalHOC = _interopRequireDefault(require("cornerstone_ui_core/lib/components/PromiseModalHOC"));

var _Input = require("cornerstone_ui_core/lib/components/Input");

var _utils = require("cornerstone_ui_core/lib/utils");

var _baseLayout = require("cornerstone_ui_core/lib/containers/BaseLayout/base-layout.service");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TextArea = _Input.Input.TextArea;
var defaultFields = {
  userName: true,
  passWord: true,
  comments: true
};

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(function (field) {
    return fieldsError[field];
  });
}

var Login = /*#__PURE__*/function (_React$Component) {
  _inherits(Login, _React$Component);

  var _super = _createSuper(Login);

  function Login(props) {
    var _this;

    _classCallCheck(this, Login);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (e) {
      e.preventDefault();

      _this.props.form.validateFields( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(err, values) {
          var res, userDetails, appName, key;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (err) {
                    _context.next = 24;
                    break;
                  }

                  _this.setState({
                    loading: true
                  });

                  _context.prev = 2;
                  _context.next = 5;
                  return (0, _baseLayout.performEsignAuth)({
                    userName: _this.props.userId,
                    passWord: values.passWord
                  });

                case 5:
                  res = _context.sent;

                  if (!(res && res.performEsignAuth)) {
                    _context.next = 17;
                    break;
                  }

                  _context.next = 9;
                  return (0, _baseLayout.findByUserApps)(_this.props.userId);

                case 9:
                  userDetails = _context.sent;
                  appName = (0, _utils.getAppName)();
                  key = userDetails.roles.filter(function (role) {
                    return role.appName === appName;
                  });
                  localStorage.setItem("jwttknkey", key[0].jwtCacheKey);
                  localStorage.setItem("jwtToken", key[0].jwtToken);

                  _this.props.onSuccess(values);

                  _context.next = 19;
                  break;

                case 17:
                  _this.setState({
                    loading: false
                  });

                  _this.setState({
                    authError: "Authentication failed"
                  });

                case 19:
                  _context.next = 24;
                  break;

                case 21:
                  _context.prev = 21;
                  _context.t0 = _context["catch"](2);

                  _this.setState({
                    loading: false
                  });

                case 24:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 21]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _this.state = {
      authError: ""
    };
    return _this;
  }

  _createClass(Login, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // To disable submit button at the beginning.
      this.props.form.validateFields();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          fields = _this$props.fields,
          form = _this$props.form,
          eSignOf = _this$props.eSignOf;
      var comments = this.props.formulaSpecificationLevel && this.props.formulaSpecificationLevel.comments || this.props.electronicBatchAction;
      var getFieldDecorator = form.getFieldDecorator,
          getFieldsError = form.getFieldsError,
          getFieldError = form.getFieldError,
          isFieldTouched = form.isFieldTouched;

      var visibleFields = _objectSpread(_objectSpread({}, defaultFields), fields); // Only show error after a field is touched.


      var userNameError = isFieldTouched("userName") && getFieldError("userName");
      var passWordError = isFieldTouched("passWord") && getFieldError("passWord");
      var commentError = isFieldTouched("comments") && getFieldError("comments");
      return /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default, {
        onKeyDown: function onKeyDown(e) {
          return _this2.setState({
            isCapsLock: e.getModifierState("CapsLock")
          });
        },
        onSubmit: this.handleSubmit
      }, this.state.loading && /*#__PURE__*/_react.default.createElement(_Loader.default, null), /*#__PURE__*/_react.default.createElement(_Row.default, {
        gutter: {
          xs: 8,
          sm: 16,
          md: 24,
          lg: 32
        }
      }, /*#__PURE__*/_react.default.createElement(_Col.default, {
        span: 24
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
        colon: false,
        validateStatus: this.state.authError ? "error" : "",
        help: userNameError || ""
      }, this.state.authError || "You have been logged out. Please login to continue.")), visibleFields.userName && /*#__PURE__*/_react.default.createElement(_Col.default, {
        span: 12
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
        colon: false,
        label: "Username"
      }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
        prefix: /*#__PURE__*/_react.default.createElement(_CornerstoneIcon.default, {
          type: "user",
          style: {
            color: "rgba(0,0,0,.25)"
          }
        }),
        disabled: true,
        value: this.props.userId
      }))), visibleFields.passWord && /*#__PURE__*/_react.default.createElement(_Col.default, {
        span: 12
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
        colon: false,
        label: "Password",
        validateStatus: passWordError ? "error" : "",
        help: passWordError || ""
      }, getFieldDecorator("passWord", {
        rules: [{
          required: true,
          message: "Please input your password"
        }]
      })( /*#__PURE__*/_react.default.createElement(_Input.Input, {
        prefix: /*#__PURE__*/_react.default.createElement(_CornerstoneIcon.default, {
          type: "lock",
          style: {
            color: "rgba(0,0,0,.25)"
          }
        }),
        type: "passWord",
        autoComplete: "off" //placeholder="Password"

      }))))), this.state.isCapsLock && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: "right",
          color: "red"
        }
      }, "Caps lock is on"), comments && visibleFields.comments && /*#__PURE__*/_react.default.createElement(_Row.default, {
        gutter: {
          xs: 8,
          sm: 16,
          md: 24,
          lg: 32
        }
      }, /*#__PURE__*/_react.default.createElement(_Col.default, {
        span: 24
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
        colon: false,
        label: "Comments",
        validateStatus: commentError ? "error" : "",
        help: commentError || ""
      }, getFieldDecorator("comments", {
        rules: [{
          required: true,
          message: "Please input your comments"
        }]
      })( /*#__PURE__*/_react.default.createElement(TextArea, {
        rows: 4,
        placeholder: "Comments"
      }))))), /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, null, /*#__PURE__*/_react.default.createElement(_CornerstoneButton.default, {
        type: "primary",
        htmlType: "submit",
        disabled: hasErrors(getFieldsError())
      }, "Login")));
    }
  }]);

  return Login;
}(_react.default.Component);

_defineProperty(Login, "defaultProps", {
  fields: defaultFields
});

var WrappedLoginForm = _CornerstoneForm.default.create({
  name: "login"
})(Login);

exports.WrappedLoginForm = WrappedLoginForm;

var _default = (0, _PromiseModalHOC.default)(WrappedLoginForm);

exports.default = _default;